
<template>
  <div>
    <v-row v-if="action.type=='gameInvitation' || action.type=='spectatorInvitation' || action.type=='competitionTeamInvitation'">
      <v-col cols="12">
        <span class="overline">Einladung von:</span>
        <user-widget
          class="mt-2 mb-2"
          :user="action.content.inviter"
          :showDefaultActions="['details']"
          :showButtons="$store.state.isLoggedIn"
        ></user-widget>
      </v-col>
      <v-col cols="12">
        <span class="overline">{{$t('common.competition')}}:</span>
      </v-col>
      <game-instance-info :gameInstance="action.content.gameInstance" :platform="action.content.platform" :game="action.content.game"></game-instance-info>
    </v-row>
    <v-row v-if="$route.query.debug == 1">
      <v-col cols="12">
        <span class="overline">Debug-Info:</span>
        <br />
        <span style="word-break:break-all;">{{JSON.stringify(action.content)}}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import gameTypeMixin from "@/mixins/gameTypeMixin";
import GameInstanceInfo from "@/widgets/content/GameInstanceInfo";

export default {
  name: "ActionDetails",
  mixins: [gameTypeMixin],
  components: { GameInstanceInfo },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  methods: {},
};
</script>